import React from 'react';
import Cart from './cart';
import { withConfig } from '../lib/withConfig';

const Checkout = props => {
  switch (process.env.NEXT_PUBLIC_APP) {
    default:
      return <Cart {...props} />;
  }
};

async function getServerSidePropsTest({ req }) {
  let host = req?.headers?.['dtc-domain'] || ""
  return { props: { host } }
}
export const getServerSideProps = withConfig(getServerSidePropsTest)

export default Checkout;
